import queryString from 'query-string'
import { request } from 'shared/helpers/sagas'
import { axiosInstance } from 'network/apis';
import axios from "axios";


export const getModeratorListRequest = async (payload) => {
  payload.id = 1
  console.log("payload in getModeratorListRequest", payload)

return await axiosInstance.get(`/moderator/client/${payload.clientId}/list`, { handlerEnabled: true })


};

export const getAllModerator = async () => {
  return await axiosInstance.get(`/moderator/get-all-moderators`, { handlerEnabled: true })
};

export default {
  getModeratorListRequest,
  getAllModerator
}